import React, { useEffect } from 'react';
import brand from '../lib/brand';

// Нэвтрэлтгүй нийтийн хуудас: App Store-ийн Privacy Policy URL ба Support URL.
const UPDATED = '2026-10-17';

const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="text-lg font-semibold text-zinc-900">{title}</h2>
    <div className="space-y-2 text-zinc-700 leading-relaxed">{children}</div>
  </section>
);

const Contact = () => (
  <ul className="list-disc pl-5">
    <li>
      Email: <a className="underline" href={`mailto:${brand.support.email}`}>{brand.support.email}</a>
    </li>
    <li>
      Утас / Phone: <a className="underline" href={`tel:+976${brand.support.phone}`}>{brand.support.phone}</a>
    </li>
  </ul>
);

const Privacy = () => {
  const app = brand.driverApp.name;
  useEffect(() => { document.title = `${brand.name} — Privacy Policy`; }, []);
  return (
    <div className="min-h-screen bg-zinc-50">
      <main className="mx-auto max-w-2xl px-4 py-10 space-y-10">
        <header className="flex flex-col items-center gap-3 text-center">
          <img src="/logo.png" alt={brand.name} className="h-16" />
          <h1 className="text-2xl font-bold text-zinc-900">{brand.name}</h1>
          <p className="text-zinc-600">Нууцлалын бодлого ба тусламж · Privacy Policy & Support</p>
          <p className="text-sm text-zinc-500">Шинэчилсэн / Updated: {UPDATED}</p>
        </header>

        <div className="space-y-6">
          <Section title="Нууцлалын бодлого">
            <p>
              Энэхүү бодлого нь {brand.name}-ийн хүргэлтийн систем болон жолоочийн «{app}» аппад хамаарна.
            </p>
            <p><strong>Цуглуулдаг мэдээлэл.</strong> Нэр, утасны дугаар (бүх хэрэглэгч). Байршил — зөвхөн
              идэвхтэй хүргэлттэй компанийн жолоочоос, ойролцоогоор минут тутам; зөвхөн хамгийн сүүлийн байршил
              хадгалагдана. Демо горимд байршил цуглуулахгүй.</p>
            <p><strong>Зорилго.</strong> Зөвхөн хүргэлт зохион байгуулахад (диспетчер жолоочийн байршлыг харах,
              хүргэлтийн төлөв бүртгэх) ашиглана. Мэдээллийг гуравдагч талд зарахгүй, дамжуулахгүй; зар сурталчилгаа,
              tracking-д ашиглахгүй.</p>
            <p><strong>Устгах.</strong> Апп-аар өөрөө бүртгүүлсэн хэрэглэгч Профайл → «Бүртгэл устгах» товчоор
              бүртгэл болон бүх демо өгөгдлөө шууд устгана. Компанийн жолоочийн бүртгэлийг компани удирддаг тул
              устгуулах бол доорх хаягаар хандана уу.</p>
            <p><strong>Холбоо барих.</strong></p>
            <Contact />
          </Section>

          <hr className="border-zinc-200" />

          <Section title="Privacy Policy">
            <p>
              This policy applies to the {brand.name} delivery system and the «{app}» courier app.
            </p>
            <p><strong>Data we collect.</strong> Name and phone number (all users). Location — only from company
              couriers while they have active deliveries, about once a minute; only the last known position is kept.
              No location is collected in demo mode.</p>
            <p><strong>Purpose.</strong> Used only to run deliveries (letting the dispatcher see courier positions and
              recording delivery status). We do not sell or share this data with third parties and do not use it for
              advertising or tracking.</p>
            <p><strong>Deletion.</strong> Users who signed up in the app can delete their account and all demo data
              at any time in the app: Profile → “Бүртгэл устгах” (Delete account). Company courier accounts are
              managed by the company; contact us below to request deletion.</p>
            <p><strong>Contact / Support.</strong></p>
            <Contact />
          </Section>
        </div>
      </main>
    </div>
  );
};

export default Privacy;
